module.exports = __webpack_public_path__ + "img/bghe44.87d7b01b.png";